import { rubIcon } from "../../../../shared/assets/svg/rubIcon";
import { Stack } from "../../../../shared/ui/Stack/Stack";
import { Text } from "../../../../shared/ui/Text/Text";
import { EndoPriceData } from "../lib/data";
import styles from './EndoPrice.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const EndoPrice = () => {

    useGSAP(() => {
        gsap.to(".endoPrice", { "--opacity": 1, 
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1,
                                    scrollTrigger: {
                                        trigger: ".endoPrice"
        }});
    }, [])

    return (  
        <div className={styles.container}>
            <Stack     
                    justifyContent = 'justifyCenter'                    
            >
                <Text type="h2" size='l' className={`endoPrice ${styles.title}`}>
                    СТОИМОСТЬ УСЛУГ
                </Text>    
            </Stack>
            {EndoPriceData.map(element => 
                <div          
                    className={styles.priceContent}
                    key={element.id}
                >

                        <Text  size='m' className={styles.text}>
                            {element.service}
                        </Text>  
                        <Text  size='m' className={styles.price}>
                            {element.price} {rubIcon()}
                        </Text>    
                </div>
            )}
        </div>
    );
}

export default EndoPrice;